import { dispatch_theme, grey, morgengrauen } from '../../../config/colors';

const mainBorder = `1px solid ${morgengrauen}`;
export const table = {
  wrapper: {
    display: 'block',
    // height: `${window.innerHeight - 347}px`,
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    color: grey
  },
  sharedWrapper: {
    display: 'block',
    // height: `${window.innerHeight - 550}px`,
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  detailWrapper: {
    display: 'block',
    height: `${window.innerHeight - 250}px`,
    position: 'relative',
    overflowY: 'auto'
  },
  sharedDetailWrapper: {
    display: 'block',
    height: `${window.innerHeight - 450}px`,
    position: 'relative',
    overflowY: 'auto'
  },
  deliveryFormWrapper: {
    height: 'auto',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  formControl: {
    margin: 8,
    minWidth: 120,
    maxWidth: 300
  },
  inheritFlex: {
    width: 'auto',
    display: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
  },
  none: {
    display: 'none'
  },
  flex: {
    flex: 1
  },
  listItem: {
    height: 50,
    display: 'block'
  },
  customernr: {
    fontSize: '12px',
    marginBottom: '5px',
    color: morgengrauen
  },
  address: {
    fontSize: '12px',
    color: '#C5C5C5',
    fontWeight: 'normal'
  },
  table: {
    borderCollapse: 'collapse',
    color: 'rgb(60, 60, 59)',
    width: '100%',
    backgroundColor: 'rgb(255, 255, 255)'
  },
  body: {
    height: 'auto',
    position: 'relative'
  },
  fixedHeader: {
    position: 'sticky',
    backgroundColor: 'white',
    zIndex: 100,
    top: 0

  },
  tr: {
    height: '48px',
    width: '100%',
    margin: '0px',
    position: 'relative',
    cursor: 'pointer',
    borderSpacing: 0,
    borderBottom: '1px solid rgb(224, 224, 224)'
  },
  selected: {
    backgroundColor: 'rgb(224, 224, 224)'
  },
  infoBorder: {
    borderBottom: mainBorder,
    borderTop: mainBorder
  },
  td: {
    paddingLeft: '24px',
    // paddingRight: '24px',
    height: '48px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    userSelect: 'none',
    fontSize: '13px',
    // overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  textTd: {
    maxWidth: 'calc(90% - 110px)',
    overflow: 'hidden'
  },
  iconTd: {
    width: '100px',
    position: 'relative',
    paddingRight: '10px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    // overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  header: {
    height: '48px',
    position: 'fixed',
    top: '130px',
    width: '400px',
    backgroundColor: 'white',
    margin: '0px'
  },
  tdActive: {
    backgroundColor: 'rgb(224, 224, 224)'
  },
  relative: {
    position: 'relative'
  },
  pndConnection: {
    position: 'absolute',
    height: '30px',
    left: '10px',
    bottom: '30px',
    border: '1px dashed rgb(224, 224, 224)'
  },
  pndDot: {
    // borderRadius: '50%',
    width: '20px',
    position: 'absolute',
    top: '15px',
    color: 'white',
    height: '20px',
    fontSize: '11px'
    // backgroundColor: 'rgb(224, 224, 224)'
  },
  addressString: {
    fontSize: '12px',
    color: '#C5C5C5',
    fontWeight: 'normal'
  },
  appointment: {
    width: '10px',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0
  }
};

export const jobStyle = {
  container: {
    position: 'relative'
  },
  resize: {
    resize: 'horizontal'
  },
  resizeVert: {
    resize: 'vertical'
  },
  resizeWrapper: {
    overflow: 'hidden'
  },
  jobsWrapper: {
    margin: '16px 0 0 0'
  },
  noPadding: {
    padding: 0
  },
  sideMargin: {
    margin: '0 8px'
  },
  bottomMargin: {
    marginBottom: 8
  },
  filterChips: {
    display: 'inline-block',
    flexWrap: 'wrap'
  },
  selectMenu: {
    whiteSpace: 'normal'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  },
  none: {
    display: 'none'
  },
  bottomToolbar: {
    top: 'auto',
    bottom: 0,
    left: 0,
    paddingLeft: 85,
    paddingRight: 16
  },
  jobViewWrap: {
    position: 'relative'
  },
  bottomToolbarShift: {
    left: 267
  },
  draggerClosed: {
    position: 'absolute',
    width: '25px',
    height: '47px',
    top: '60px',
    left: '-10px',
    backgroundColor: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'middle',
    zIndex: 410,
    opacity: '1',
    boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px'
  },
  draggerOpen: {
    position: 'absolute',
    width: '61px',
    height: '47px',
    borderLeft: '1px solid rgba(0, 0, 0, .06)',
    top: '48px',
    left: '365px',
    backgroundColor: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 410,
    opacity: '1'
    // boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px'
  },
  openDraggerArrow: {
    transform: 'rotate(-90deg)',
    color: grey,
    zIndex: 99
  },
  closedDraggerArrow: {
    transform: 'rotate(90deg)',
    zIndex: 99
  },
  jobTable: {
    // maxWidth: '450px',
    paddingRight: 0
  },

  toolbarWrapper: {
    padding: 8,
    marginBottom: dispatch_theme.spacing(1)
  },
  toolbarLeftWrapper: {
    minWidth: 450,
    zIndex: 999,
    paddingLeft: 8
  },
  lineBreak: {
    whiteSpace: 'pre-line'
  },
  routeSelectionStyle: {
    position: 'absolute',
    zIndex: 444,
    backgroundColor: 'transparent',
    width: 40,
    height: 'auto',
    overflowY: 'scroll',
    top: 100,
    bottom: 57,
    left: 15
  },
  tourSelectorDot: {
    width: 20,
    height: 20,
    display: 'flex',
    backgroundColor: 'white',
    borderRadius: '50%',
    marginBottom: 15,
    cursor: 'pointer'
  },
  center: {
    zIndex: 555,
    alignItems: 'center',
    justifyContent: 'center'
  },
  marginTop: {
    marginTop: 8
  },
  timelineWrapperStyle: {
    /* position: 'absolute',
    bottom: 46, // 60,
    left: 0,
    right: 0,
    zIndex: 999, */
    backgroundColor: 'white'// 'rgba(255,255,255,0.7)'
  },
  datePopper: {
    backgroundColor: 'white'
  }
};

export const creatorStyles = {
  interfaceWrapper: {
    position: 'absolute',
    top: '8px',
    left: '16px',
    fontSize: 14,
    width: '450px',
    height: 'auto',
    zIndex: 1111,
    backgroundColor: 'white'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  inputIcon: {
    width: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  conenctionLine: {
    position: 'absolute',
    border: '1px dashed #C5C5C5',
    height: '26px',
    left: '17px',
    top: '-15px'
  },
  commonInput: {
    width: '308px', // "358px",
    height: '46px',
    border: 'none',
    paddingLeft: '10px'
  },
  suggestionItem: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: 45,
    paddingLeft: 15
  }
};

export const jobformStyle = {
  hyphen: {
    padding: 4
  },
  row: {
    padding: 8
  },
  firstrow: {
    padding: 8
  },
  lastrow: {
    borderBottom: '1px solid rgba(0, 0, 0, .06)',
    padding: '16px 8px',
    margin: '0px'
  },
  p: {
    fontSize: 15
  },
  textfield: {
    paddingLeft: 20
  },
  noMargin: {
    margin: 0
  },
  noPadding: {
    padding: 0,
    wordBreak: 'break-word'
  },
  sidePadding: {
    padding: '0px 8px'
  },
  remove: { position: 'absolute', right: 0, top: -10 },
  time: {
    width: '100%'
  },
  maxWidth: {
    maxWidth: '118px'
  },
  flexEnd: {
    justifyContent: 'center'
  }
};

export const suggestionTheme = (stepTwo: any) => ({
  container: {
    display: 'block',
    width: '450px',
    backgroundColor: 'white',
    position: 'relative',
    zIndex: 'initial'
  },
  input: {
    ...creatorStyles.commonInput,
    borderBottom: stepTwo ? '1px solid rgba(0, 0, 0, .06)' : 'none'
  },
  suggestionsContainer: {
    width: '100%'
  },
  suggestionsContainerOpen: {
    paddingTop: '10px',
    marginBottom: stepTwo ? '20px' : 0,
    borderBottom: '1px solid #C5C5C5',
    maxHeight: 350,
    overflow: 'auto'
  },
  suggestionsList: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  suggestion: {},
  suggestionHighlighted: {
    backgroundColor: 'rgba(0, 0, 0, .06)'
  }
});
export const sndSuggestionTheme = {
  container: {
    display: 'block',
    width: '450px',
    backgroundColor: 'white',
    position: 'relative',
    borderBottom: '1px solid rgba(0, 0, 0, .06)'
  },
  input: {
    ...creatorStyles.commonInput
  },
  suggestionsContainer: {
    width: '100%'
  },
  suggestionsContainerOpen: {
    paddingTop: '10px',
    borderTop: '1px solid rgba(0, 0, 0, .06)',
    maxHeight: 350,
    overflow: 'auto'
  },
  suggestionsList: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  suggestion: {},
  suggestionHighlighted: {
    backgroundColor: 'rgba(0, 0, 0, .06)'
  }
};
